module.exports = __webpack_public_path__ + "static/media/hamburger-icon.c9df60f6.png";